<template>
  <div id="user">
    <el-container class="container" :style="{height:containerHeight}">
      <el-main class="main">
        <div class="main-in">
          <p>我的服务</p>
          <div class="table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{
background:'#FAFAFA',color:'#333333' }" :cell-style='cellStyle'>
              <el-table-column prop="number" label="编号" width="259" type="index">
              </el-table-column>
              <el-table-column prop="project" label="服务项目" width="259">
              </el-table-column>
              <el-table-column prop="contract" label="合同编号">
              </el-table-column>
              <el-table-column prop="quantity" label="产品数量" width="259" type="index">
              </el-table-column>
              <el-table-column prop="term" label="服务期限">
              </el-table-column>
              <el-table-column prop="operation" label="操作" width="259">
                <template slot-scope="{row}">
                  <span @click="look">{{row.operation.split('|')[0]}}</span>
                  <span>|</span>
                  <span @click="record">{{row.operation.split('|')[1]}}</span>
                  <span>|</span>
                  <span @click="appointment(row)"
                    :class="strColor(row.operation.split('|')[2])">{{row.operation.split('|')[2]}}</span>
                </template>
              </el-table-column>
            </el-table>
            <!--预约弹框-->
            <el-dialog :lock-scroll="false" v-if="dialogVisible" title="预约"
              :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
              :close-on-press-escape="false" @close="ruleForm.textarea = ''
">
              <div class="dialog">
                <div style="margin-bottom: 16px">
                  <span style="margin-right: 165px;">
                    <sapn class="key">服务项目：</sapn>
                    <span class="value">DGX A800</span>
                  </span>
                  <span>
                    <span class="key">合同编号：</span>
                    <span class="value">SSH 登录</span>
                  </span>
                </div>
                <div style="margin-bottom: 14px;">
                  <span style="margin-right: 197px;">
                    <span class="key">产品数量：</span>
                    <span class="value">10台</span>
                  </span>
                  <span>
                    <span class="key">服务期限：</span>
                    <span class="value">2021/1/1--2030/1/1</span>
                  </span>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                  <el-form-item label="预约详情：" prop="textarea">
                    <el-input type="textarea" v-model="ruleForm.textarea" placeholder="请输入"
                      resize="none" style=""></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="success" @click="handleDetermine" size="small">确 定</el-button>
              </span>
            </el-dialog>
            <!--查看弹框-->
            <el-dialog :lock-scroll="false" title="详情" :visible.sync="visible" width="30%"
              :close-on-click-modal="false" :close-on-press-escape="false">
              <div class="dialog">
                <div style="margin-bottom: 16px">
                  <span style="margin-right: 165px;">
                    <sapn class="key">服务项目：</sapn>
                    <span class="value">DGX A800</span>
                  </span>
                  <span>
                    <span class="key">合同编号：</span>
                    <span class="value">SSH 登录</span>
                  </span>
                </div>
                <div style="margin-bottom: 16px;">
                  <span style="margin-right: 197px;">
                    <span class="key">产品数量：</span>
                    <span class="value">10台</span>
                  </span>
                  <span>
                    <span class="key">服务期限：</span>
                    <span class="value">2021/1/1--2030/1/1</span>
                  </span>
                </div>
                <div style="margin-top: 24px;">
                  <span class="key">预约详情：</span>
                  <div class="details value">
                    NVIDIA AI 初学者工具包为您的团队提供所需的一切，从世界级的 AI
                    平台，到优化的软件和工具，再到咨询服务，让您的人工智能计划快速启动并运行。无需浪费时间和金钱建立人工智能平台。在一天内接通电源，在一周内确定用例，并更快地开始生产模型
                  </div>
                </div>
                <div style="margin-top: 24px;">
                  <span class="key">备注：</span>
                  <div class="details value">
                    NVIDIA DGX™ A100 是适用于所有 AI 工作负载的通用系统，为全球首款 5 petaFLOPS AI
                    系统提供超高的计算密度、性能和灵活性。NVIDIA DGX A800 采用全球超强大的加速器 NVIDIA A100 Tensor Core
                    GPU，可让企业将深度学习训练、推理和分析整合至一个易于部署的统一 AI 基础架构中，该基础架构具备直接联系 NVIDIA AI 专家的功能。
                  </div>
                </div>
              </div>
            </el-dialog>
            <div class="pagination">
              <el-pagination style="text-align:right" background layout="prev, pager, next"
                :total="1000">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "User",
  data () {
    var validateText = (rule, value, callback) => {
      if (value === '') {
        callback('请输入预约详情')
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      visible: false,
      containerHeight:null,
      ruleForm: {
        textarea: '',
      },
      rules: {
        textarea: [
          { validator: validateText, trigger: 'blur' }
        ]
      },
      tableData: [
        {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'
        },
        {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 已预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        }, {
          number: '1',
          project: 'DGX A800',
          contract: '2021100120221001',
          quantity: '1',
          term: '2021/10/01 - 2022/10/01',
          operation: '查看 | 服务记录 | 预约'

        },
      ]
    }
  },
  created(){
    this.containerHeight = document.body.clientHeight - 104 + 'px'
  },
  methods: {
    appointment (row) {
      if (row.operation.split('|')[2].trim() == '已预约') {
        return
      }
      this.dialogVisible = true
    },
    record () {
      this.$router.push('/user/singleService')
    },
    look () {
      this.visible = true
    },
    handleClose () {
      this.dialogVisible = false
      this.ruleForm.textarea = ''
    },
    handleDetermine () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          alert('111')
        } else {
          alert('222')
        }
      })
    },
    // 单元格的 style 的回调方法
    cellStyle ({ columnIndex }) {
      if (columnIndex === 5) {
        return `color: #77BA00;`
      } else {
        return ''
      }
    },
    strColor (str) {
      if (str.trim() == '已预约') return 'strColor'
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  background-color: #f5f5f5;
}
.main-in {
  background-color: #fff;
  padding: 24px 28px 24px 24px;
}
.main-in p {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 29px;
}
.table /deep/tbody tr:hover > td {
  cursor: pointer;
  background-color: #fafafa;
}
.dialog {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin-top: 15px;
  padding: 24px;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
.key {
  color: #666666;
  font-size: 14px;
}
.value {
  color: #333333;
  font-size: 14px;
}
.details {
  height: 144px;
  border: 1px solid #d9d9d9;
  margin-top: 12px;
  padding: 4px 14px 0 12px;
}
::v-deep .el-textarea__inner {
  height: 144px;
  border-radius: 0;
  padding-left: 12px;
}
::v-deep .el-textarea__inner::placeholder {
  color: #999999;
  font-size: 14px;
}
::v-deep .el-dialog__footer {
  padding: 15px 24px 15px 0;
}
.el-button {
  border-radius: 0;
}
.el-button--success {
  color: #fff;
  background-color: #77ba00;
  border-color: #77ba00;
}
.el-button--success:hover {
  background-color: #77ba00;
}
.el-button--default:hover {
  background-color: #fff;
  color: #666666;
  border: 1px solid #dddddd;
}
.pagination {
  margin-top: 24px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #77ba00;
  border: none;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #606266;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-pagination button {
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
::v-deep .el-dialog__close:hover {
  color: #77ba00 !important;
}
.el-form-item {
  margin-bottom: 0px;
}
.strColor {
  color: #999;
}
#user ::v-deep .el-dialog {
  min-width:576px;
  margin: 0 auto 0px;
}
</style>
